import React, { useState, Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Seo } from '../../components';
import { Logo } from '../../components';
import { Link } from 'react-router-dom';
import { APIService } from '../../services/api-service';
import { createOrUpdate } from '../api/mutation';
import Creatable from 'react-select/creatable';
import AsyncCreatableSelect from 'react-select/async-creatable';

const COUNTRY_CODES = [
    { code: '+44', country: 'UK' },
    { code: '+1', country: 'USA' },
    { code: '+61', country: 'Australia' },
    { code: '+65', country: 'Singapore' },
    { code: '+81', country: 'Japan' },
    { code: '+86', country: 'China' },
    { code: '+91', country: 'India' },
    { code: '+971', country: 'UAE' },
];

const predefinedProducts = [
    'Dine-in Service', 'Takeaway', 'Delivery', 'Catering', 'Food Preparation',
    'Beverages', 'Special Events', 'Fresh Produce', 'Dairy Products',
    'Bakery Items', 'Packaged Foods', 'Household Items', 'Personal Care',
    'Greeting Cards', 'Gift Wrapping', 'Custom Gifts', 'Seasonal Items',
    'Home Decor', 'Collectibles', 'Personalized Items'
];

const industryOptions = [ "Restaurant", "Grocery", "Gift Shop" ];

const loadIndustryOptions = (inputValue, callback) => {
    const options = industryOptions.map((option) => ({ value: option, label: option }));
    callback(options);
};

let handleEnquiryForm

const PhoneInputSection = ({ enquiryForm, setEnquiryForm, errors }) => (
    <div className="col-12 col-lg-4">
        <div className="form-group">
            <label htmlFor="phone">Phone Number*</label>
            <div className='d-flex'>
                <select
                    className="form-control appInput"
                    style={{ marginRight: '10px', padding: '10px', borderRadius: '5px', border: '1px solid #ccc' }}
                    value={enquiryForm.countryCode}
                    onChange={(e) => setEnquiryForm(prev => ({ ...prev, countryCode: e.target.value }))}
                >
                    {COUNTRY_CODES.map(({ code, country }) => (
                        <option key={code} value={code}>{`${code} ${country}`}</option>
                    ))}
                </select>
                <input
                    type="text"
                    className="form-control appInput"
                    id="phone"
                    name="phone"
                    value={enquiryForm.phone}
                    onChange={handleEnquiryForm}
                    placeholder="Enter phone number"
                    required
                    style={{ padding: '10px', borderRadius: '5px', border: '1px solid #ccc' }}
                />
                {errors.phone && <div style={{ color: 'red' }}>{errors.phone}</div>}
            </div>
        </div>
    </div>
);

const ProductsServicesSection = ({ selectedProducts, setSelectedProducts }) => {
    const options = predefinedProducts.map(product => ({ value: product, label: product }));

    const handleChange = (selectedOptions) => {
        setSelectedProducts(selectedOptions ? selectedOptions.map(option => option.value) : []);
    };

    const selectedOptions = selectedProducts.map(product => ({ value: product, label: product }));

    return (
        <div className="col-12 col-lg-12">
            <div className="form-group">
                <label>Products and Services Offered*</label>
                <Creatable
                    isMulti
                    options={options}
                    onChange={handleChange}
                    value={selectedOptions}
                    placeholder="Select or type..."
                    styles={{
                        control: (base, state) => ({...base, border: state.isFocused ? '1px solid #ff7614' : '1px solid #ccc',boxShadow: state.isFocused ? '0 0 0 1px #ff7614' : 'none',
                            '&:hover': {
                                border: state.isFocused ? '1px solid #ff7614' : '1px solid #ccc'
                            },
                            borderRadius: '10px',
                            width: '100%'
                        }), 
                        multiValue: (base) => ({ ...base, backgroundColor: '#e0e0e0', borderRadius: '3px', padding: '2px 5px', margin: '2px' }),
                        multiValueLabel: (base) => ({ ...base, color: '#333', fontSize: '14px', backgroundColor: '#e0e0e0' }),
                        multiValueRemove: (base) => ({ ...base, cursor: 'pointer', ':hover': { backgroundColor: '#ff7614', color: 'white' } }),
                        valueContainer: (base) => ({ ...base, padding: '2px 8px', }),
                        input: (base) => ({ ...base, margin: '0', padding: '0' }),
                    }}
                />
            </div>
        </div>
    );
};

const EnquiryForm = ({ formType }) => {
    const [enquiryForm, setEnquiryForm] = useState({
        name: '',
        address: '',
        phone: '',
        email: '',
        websiteUrl: '',
        businessType: '',
        message: '',
        contactName: '',
        storeName: '',
        storeDescription: '',
        industryType: '',
        facebook: '',
        instagram: '',
        yearOfEstablishment: '',
        employeeCount: '',
        countryCode: '+44',
        storeGrowthStage: '',
        pincode: '',
        region: '',
        StorePhone:'',
        StoreEmail:''
    });
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [errors, setErrors] = useState({
        email: '',
        phone: '',
        pincode: '',
    });

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submissionError, setSubmissionError] = useState(false);

    handleEnquiryForm = (e) => {
        const { name, value } = e.target;
        setEnquiryForm((prevState) => ({ ...prevState, [name]: value }));
    };

    const validateForm = (formData) => {
        const errors = {};

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formData.email)) {
            errors.email = "Please enter a valid email address.";
        }
        const validateUrl = (url, type) => {
            if (!url) return "";    
            if (!url.startsWith("https://www."))    url = `https://www.${url.replace(/^https?:\/\//, "").replace(/^www\./, "")}`;            

            if (type === "facebook" && url !== "https://www.facebook.com" && !url.replace("https://www.facebook.com/", "")) {
                return "Please enter your complete Facebook profile URL";
            }
            if (type === "instagram" && url !== "https://www.instagram.com" && !url.replace("https://www.instagram.com/", "")) {
                return "Please enter your complete Instagram profile URL";
            }
            return "";
        };

        if (formData.facebook) {
            const facebookError = validateUrl(formData.facebook, "facebook");
            if (facebookError) errors.facebook = facebookError;
            else formData.facebook = formData.facebook.startsWith("https://www.") ? formData.facebook : `https://www.${formData.facebook.replace(/^https?:\/\//, "").replace(/^www\./, "")}`;
        }
        if (formData.instagram) {
            const instagramError = validateUrl(formData.instagram, "instagram");
            if (instagramError) errors.instagram = instagramError;
            else formData.instagram = formData.instagram.startsWith("https://www.") ? formData.instagram : `https://www.${formData.instagram.replace(/^https?:\/\//, "").replace(/^www\./, "")}`;
        }
        if (formData.websiteUrl) {
            formData.websiteUrl = formData.websiteUrl.startsWith("https://www.") ? formData.websiteUrl : `https://www.${formData.websiteUrl.replace(/^https?:\/\//, "").replace(/^www\./, "")}`;
        }

        return {
            isValid: Object.keys(errors).length === 0,
            errors,
            formData
        };
    };

    const formatDetailsForEmail = (data) => {
    return `
        <pre>
<strong>Contact Details:</strong>\n

Name: ${data.contactName}\n
Phone: ${data.phoneNumber}\n
Email: ${data.email}\n\n

<strong>Business Information:</strong>\n

Store Name: ${data.storeName}\n
Business Description: ${data.businessDescription}\n
Address: ${data.address}\n
Region: ${data.region}\n
Pin Code: ${data.pincode}\n
Lead Status: ${data.leadStatus}\n
Business Type: ${data.businessType}\n
Industry Type: ${data.industryType}\n
Products & Services Offered: ${data.productsServicesOffered.length > 0 ? data.productsServicesOffered.join(", ") : "N/A"}\n
Store Growth Stage: ${data.storeGrowthStage}\n
Year Established: ${data.yearEstablished}\n
Employee Count: ${data.employeeCount}\n\n

<strong>Online Presence:</strong>\n

Website: ${data.businessWebsite || "N/A"}\n
Facebook: ${data.socialMediaLinks.Facebook || "N/A"}\n
Instagram: ${data.socialMediaLinks.Instagram || "N/A"}\n

<strong>Additional Comments:</strong>\n

${data.comments.length > 0 ? data.comments.map(comment => `- ${comment}`).join("\n") : "No additional comments."}
        </pre>
    `;
};


    const submitForm = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setSubmissionError(false);

        const validation = validateForm(enquiryForm);
        if (!validation.isValid) {
            setErrors(validation.errors);
            setIsSubmitting(false);
            return;
        }

        let businessHours =  {
            Monday: { start: null, end: null },
            Tuesday: { start: null, end: null },
            Wednesday: { start: null, end: null },
            Thursday: { start: null, end: null },
            Friday: { start: null, end: null },
            Saturday: { start: null, end: null },
            Sunday: { start: null, end: null },
        }
        const requestData = formType === 'enquiry' ? {
            contactName: validation.formData.contactName || "",
            phoneNumber: `${validation.formData.countryCode}${validation.formData.phone}` || "",
            email: validation.formData.email || "",
            message: validation.formData.message,
            comments: [],
            leadStatus:"Contact",
            businessHours: businessHours, 
        } : {
            contactName: validation.formData.contactName || "",
            phoneNumber: `${validation.formData.countryCode}${validation.formData.phone}` || "",
            email: validation.formData.email || "",
            storeName: validation.formData.storeName || "",
            businessDescription: validation.formData.storeDescription || "",
            address: validation.formData.address || "",
            region: validation.formData.region || "",
            pincode: validation.formData.pincode || "",
            leadStatus:"Prospect",
            businessType: validation.formData.businessType || "",
            industryType: validation.formData.industryType || "",
            productsServicesOffered: selectedProducts || [],
            storeGrowthStage: validation.formData.storeGrowthStage || "",
            businessWebsite: validation.formData.websiteUrl || "",
            socialMediaLinks: {
                Facebook: validation.formData.facebook || "",
                Instagram: validation.formData.instagram || ""
            },
            yearEstablished: validation.formData.yearOfEstablishment || "",
            employeeCount: validation.formData.employeeCount || "",
            message: validation.formData.message,
            comments:[],
            businessHours: businessHours,
        };

        try {
            const {data} = await createOrUpdate({contacts:requestData});
            if (data.success) {
                alert("Form submitted successfully, you will receive an email shortly, Thank you.");
                setEnquiryForm({
                    name: '', address: '', phone: '', email: '', websiteUrl: '',
                    businessType: '', message: '', contactName: '', storeName: '',
                    storeDescription: '', industryType: '', facebook: '', instagram: '',
                    yearOfEstablishment: '', employeeCount: '', storeGrowthStage: '',
                    pincode: '', region: '', StorePhone: '', StoreEmail: '', countryCode: ''
                });
                setSelectedProducts([]);
                setSelectedOption(null);
            }
            // else if(data.code===11000){
            //     alert("Given phone number already exists");
            // }
            else{
                alert("Error in form submission, Please try again.");
            }
        } catch (error) {
            setSubmissionError(true);
        } finally {
            setIsSubmitting(false);
        }
        try{
            let response
            response = await APIService.sendEmail({
                type: formType === "enquiry" ? "enquiry" : "onBoarding",
                to: requestData.email,
                from: "support@datumailabs.com",
                name: requestData.contactName,
                company: requestData.storeName ? requestData.storeName : "",
                subject: formType === "enquiry" ? "Enquiry Email" : "Register Email",
                message: formType === "enquiry" ? `${requestData.message}\n\n<br/><br/><strong>Phone:</strong> ${requestData.phoneNumber}\n\n`: `${requestData.message}\n\n<br/><br/><strong>Details:</strong>\n${formatDetailsForEmail(requestData)}`,
            });
            if (response.code !== 200) {
                setSubmissionError(true);
                return;
            }
            e.target.reset();
        } catch (error) {
            setSubmissionError(true);
        } finally {
            setIsSubmitting(false);
        }
    };

    const [pageTitle] = useState("Digital Commerce and Marketing for Hyperlocal Businesses");

    return (
        <Fragment>
            <Seo title={`${pageTitle}`} />
            <HeaderThree imgPath="../../images/full_logo.png" />
            <section style={{ backgroundColor: '#fff', padding: '20px', paddingTop: '80px' }} id="home">
                <div className="container">
                    <h2 style={{ textAlign: 'center', marginBottom: '20px' }} className="form-title">{formType === 'register' ? 'Onboarding Form' : 'Enquiry Form'}</h2>
                    <form name="enquiryForm" onSubmit={submitForm} id="enquiryForm">
                        <div className="row col-12">
                            {formType === 'register' && (
                                <div className="col-12">
                                    <h5>Basic Information</h5>
                                </div>
                            )}
                            <div className="col-12 col-lg-4">
                                <div className="form-group">
                                    <label htmlFor="contactName">Contact Name*</label>
                                    <input
                                        type="text"
                                        className="form-control appInput"
                                        id="contactName"
                                        name="contactName"
                                        value={enquiryForm.contactName}
                                        onChange={handleEnquiryForm}
                                        required
                                        style={{ padding: '10px', borderRadius: '5px', border: '1px solid #ccc' }}
                                    />
                                </div>
                            </div>
                            <PhoneInputSection enquiryForm={enquiryForm} setEnquiryForm={setEnquiryForm} errors={errors} />
                            <div className="col-12 col-lg-4">
                                <div className="form-group">
                                    <label htmlFor="email">Email*</label>
                                    <input
                                        type="email"
                                        className="form-control appInput"
                                        id="email"
                                        name="email"
                                        value={enquiryForm.email}
                                        onChange={handleEnquiryForm}
                                        required
                                        style={{ padding: '10px', borderRadius: '5px', border: '1px solid #ccc' }}
                                    />
                                    {errors.email && <div style={{ color: 'red' }}>{errors.email}</div>}
                                </div>
                            </div>

                            {formType === 'register' && (
                                <>
                                    <div className="col-12">
                                        <h5>Business Information</h5>
                                    </div>
                                    <div className="col-12 col-lg-12">
                                        <div className="form-group">
                                            <label htmlFor="storeName">Store Name*</label>
                                            <input
                                                type="text"
                                                className="form-control appInput"
                                                id="storeName"
                                                name="storeName"
                                                value={enquiryForm.storeName}
                                                onChange={handleEnquiryForm}
                                                required
                                                style={{ padding: '10px', borderRadius: '5px', border: '1px solid #ccc' }}
                                            />
                                        </div>
                                    </div>
                                    
                                    
                                    <div className="col-12 col-lg-6">
                                        <div className="form-group">
                                            <label htmlFor="storeDescription">Description*</label>
                                            <textarea
                                                className="form-control appInput"
                                                id="storeDescription"
                                                name="storeDescription"
                                                rows="3"
                                                value={enquiryForm.storeDescription}
                                                onChange={handleEnquiryForm}
                                                required
                                                style={{ padding: '10px', borderRadius: '5px', border: '1px solid #ccc', width: '100%' }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6">
                                        <div className="form-group">
                                            <label htmlFor="address">Address*</label>
                                            <textarea
                                                type="text"
                                                className="form-control appInput"
                                                id="address"
                                                name="address"
                                                value={enquiryForm.address}
                                                onChange={handleEnquiryForm}
                                                required
                                                style={{ padding: '10px', borderRadius: '5px', border: '1px solid #ccc' }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-3">
                                        <div className="form-group">
                                            <label htmlFor="region">Region*</label>
                                            <input
                                                type="text"
                                                className="form-control appInput"
                                                id="region"
                                                name="region"
                                                value={enquiryForm.region}
                                                onChange={handleEnquiryForm}
                                                required
                                                style={{ padding: '10px', borderRadius: '5px', border: '1px solid #ccc' }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-3">
                                        <div className="form-group">
                                            <label htmlFor="pincode">Pincode*</label>
                                            <input
                                                type="text"
                                                className="form-control appInput"
                                                id="pincode"
                                                name="pincode"
                                                value={enquiryForm.pincode}
                                                onChange={handleEnquiryForm}
                                                required
                                                style={{ padding: '10px', borderRadius: '5px', border: '1px solid #ccc' }}
                                            />
                                            {errors.pincode && <div style={{ color: 'red' }}>{errors.pincode}</div>}
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-3">
                                        <div className="form-group">
                                            <label htmlFor="yearOfEstablishment">Year of Establishment</label>
                                            <input
                                                type="number"
                                                className="form-control appInput"
                                                id="yearOfEstablishment"
                                                name="yearOfEstablishment"
                                                value={enquiryForm.yearOfEstablishment}
                                                onChange={handleEnquiryForm}
                                                style={{ padding: '10px', borderRadius: '5px', border: '1px solid #ccc' }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-3">
                                        <div className="form-group">
                                            <label htmlFor="employeeCount">Employee Count</label>
                                            <input
                                                type="number"
                                                className="form-control appInput"
                                                id="employeeCount"
                                                name="employeeCount"
                                                value={enquiryForm.employeeCount}
                                                onChange={handleEnquiryForm}
                                                style={{ padding: '10px', borderRadius: '5px', border: '1px solid #ccc' }}
                                            />
                                        </div>
                                    </div>
                                    <ProductsServicesSection selectedProducts={selectedProducts} setSelectedProducts={setSelectedProducts} />
                                    <div className="col-12 col-lg-4">
                                        <div className="form-group">
                                            <label htmlFor="industryType">Industry Type*</label>
                                            <AsyncCreatableSelect
                                                cacheOptions
                                                loadOptions={loadIndustryOptions}
                                                onChange={(selectedOption) => {
                                                    setSelectedOption(selectedOption);
                                                    setEnquiryForm(prev => ({
                                                        ...prev,
                                                        industryType: selectedOption ? selectedOption.value : ''
                                                    }));
                                                }}
                                                value={selectedOption}
                                                placeholder="Select or create.."
                                                isClearable
                                                required
                                                styles={{
                                                    control: (base, state) => ({...base, border: state.isFocused ? '1px solid #ff7614' : '1px solid #ccc',boxShadow: state.isFocused ? '0 0 0 1px #ff7614' : 'none',
                                                        '&:hover': {
                                                            border: state.isFocused ? '1px solid #ff7614' : '1px solid #ccc'
                                                        },
                                                        borderRadius: '10px',
                                                        width: '100%'
                                                    }), 
                                                    multiValue: (base) => ({ ...base, backgroundColor: '#e0e0e0', borderRadius: '3px', padding: '2px 5px', margin: '2px' }),
                                                    multiValueLabel: (base) => ({ ...base, color: '#333', fontSize: '14px' }),
                                                    multiValueRemove: (base) => ({ ...base, cursor: 'pointer', ':hover': { backgroundColor: '#ff7614', color: 'white' } }),
                                                    valueContainer: (base) => ({ ...base, padding: '2px 8px' }),
                                                    input: (base) => ({ ...base, margin: '0', padding: '0' }),
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-4">
                                        <div className="form-group">
                                            <label htmlFor="businessType">Business Type*</label>
                                            <select
                                                className="form-control appInput"
                                                id="businessType"
                                                name="businessType"
                                                value={enquiryForm.businessType}
                                                onChange={handleEnquiryForm}
                                                required
                                                style={{ padding: '10px', borderRadius: '5px', border: '1px solid #ccc' }}
                                            >
                                                <option value="" disabled>Select Business Type</option>
                                                <option value="Small">Small</option>
                                                <option value="Medium">Medium</option>
                                                <option value="Large">Large</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-4">
                                        <div className="form-group">
                                            <label htmlFor="storeGrowthStage">Growth Stage*</label>
                                            <select
                                                className="form-control appInput"
                                                id="storeGrowthStage"
                                                name="storeGrowthStage"
                                                value={enquiryForm.storeGrowthStage}
                                                onChange={handleEnquiryForm}
                                                required
                                                style={{ padding: '10px', borderRadius: '5px', border: '1px solid #ccc' }}
                                            >
                                                <option value="" disabled>Select Growth Stage</option>
                                                <option value="Startup">Startup</option>
                                                <option value="Growing">Growing</option>
                                                <option value="Established">Established</option>
                                                <option value="Enterprise">Enterprise</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-4">
                                        <div className="form-group">
                                            <label htmlFor="websiteUrl">Website URL</label>
                                            <input
                                                className="form-control appInput"
                                                id="websiteUrl"
                                                name="websiteUrl"
                                                value={enquiryForm.websiteUrl}
                                                onChange={handleEnquiryForm}
                                                style={{ padding: '10px', borderRadius: '5px', border: '1px solid #ccc' }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-4">
                                        <div className="form-group">
                                            <label htmlFor="facebook">Facebook URL</label>
                                            <input
                                                className="form-control appInput"
                                                id="facebook"
                                                name="facebook"
                                                value={enquiryForm.facebook}
                                                onChange={handleEnquiryForm}
                                                style={{ padding: '10px', borderRadius: '5px', border: '1px solid #ccc' }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-4">
                                        <div className="form-group">
                                            <label htmlFor="instagram">Instagram URL</label>
                                            <input
                                                className="form-control appInput"
                                                id="instagram"
                                                name="instagram"
                                                value={enquiryForm.instagram}
                                                onChange={handleEnquiryForm}
                                                style={{ padding: '10px', borderRadius: '5px', border: '1px solid #ccc' }}
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                            <div className="col-12">
                                <div className="form-group">
                                    <label htmlFor="message">Message</label>
                                    <textarea
                                        className="appInput"
                                        id="message"
                                        name="message"
                                        rows="5"
                                        value={enquiryForm.message}
                                        onChange={handleEnquiryForm}
                                        required
                                        style={{ padding: '10px', borderRadius: '5px', border: '1px solid #ccc', width: '100%' }}
                                    ></textarea>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="position-relative d-flex">
                                    <span className="buttonWrapper position-relative">
                                        <span className="ol-1"></span>
                                        <button
                                            id="enquirySubmit"
                                            className="btnOrange customBtn"
                                            type="submit"
                                            title="Send Enquiry"
                                            disabled={isSubmitting || errors.email || errors.phone || errors.pincode}
                                            style={{ padding: '10px 20px', borderRadius: '5px', backgroundColor: '#ff7614', color: '#fff', border: 'none' }}
                                        >
                                            {isSubmitting && "Sending..."}
                                            {submissionError && "Try Again"}
                                            {!isSubmitting && !submissionError && "Submit"}
                                        </button>
                                        <span className="ol-2"></span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </section>
        </Fragment>
    );
};

const HeaderThree = ({ imgPath }) => {
    const [isDesktop, setIsDesktop] = useState(window.innerWidth > 960);
    useEffect(() => {
        const handleResize = () => {
            setIsDesktop(window.innerWidth > 960);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <Fragment>
            <header className="vs-header header-layout2" style={{ padding: '0px 0px', backgroundColor: '#f8f9fa', height: "100px" }}>
                <div className="container" style={{ height: "100px" }}>
                    <div className="menu-area align-items-center justify-content-center" style={{ height: isDesktop ? "100px" : "auto" }}>
                        <div className="row align-items-center justify-content-between">
                            <div className="col-auto" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: isDesktop ? "20px" : "0" }}>
                                {
                                    imgPath ?
                                        <Logo image={imgPath} className="logo-style1" style={{ maxHeight: '100%', width: 'auto' }} /> :
                                        <Logo image="images/full_logo.png" className="logo-style1" style={{ maxHeight: '100%', width: 'auto' }} />
                                }
                            </div>
                            <div className="sub-menu col-auto menu-item-has-children" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: isDesktop ? "20px" : "0" }}>
                                <Link
                                    to="/"
                                    style={{
                                        textDecoration: 'none',
                                        color: "black",
                                        transition: 'background-color 0.3s ease'
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.color = '#ff7614'}
                                    onMouseLeave={(e) => e.currentTarget.style.color = 'black'}
                                >
                                    Home
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </Fragment>
    );
};

EnquiryForm.propTypes = {
    formType: PropTypes.oneOf(['enquiry', 'register']).isRequired,
};

export { EnquiryForm, HeaderThree };